import { useStrict } from "mobx";
import * as React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";

import Button from '@material-ui/core/Button';
import { blue, lightBlue, orange } from "@material-ui/core/colors";
import Snackbar from '@material-ui/core/Snackbar';
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import Close from "@material-ui/icons/Close";

import Boarding from "./boarding";
import BuyMeACoffee from "./buy-me-a-coffee";
import Discount from "./Discount";
import Elements from "./elements";
import Footer from "./Footer";
import Home from "./home";
import PageNotFound from "./page-not-found";
import Promo from "./Promo";

import Routes from "./Routes";

import "typeface-rubik";

useStrict(true);
// https://material-ui-next.com/customization/themes/
const color = "rgba(0, 0, 0, 0.87)";
const theme = createMuiTheme({
    palette: {
        primary: blue,
        error: orange,
        secondary: lightBlue
    },
    typography: {
        fontFamily: "Rubik, sans-serif",
        caption: {
            fontSize: "16px"
        },
        body1: {
            fontSize: "calc(.27027vw + 15.13514px)",
            color: "rgba(0, 0, 0, 0.54)"
        },
        body2: {
            fontSize: "calc(.27027vw + 15.13514px)",
            fontWeight: 400,
            color
        },
        headline: {
            fontSize: "calc(.40541vw + 16.7027px)",
            fontWeight: 300
        },
        display1: {
            fontSize: "calc(1.35135vw + 25.67568px)",
            fontWeight: 400,
            color
        },
        display2: {
            fontSize: "calc(1.21622vw + 20.10811px)",
            fontWeight: 400,
            color
        },
        display3: {
            fontSize: "calc(.40541vw + 16.7027px)",
            fontWeight: 400,
            color
        },
        display4: {
            fontSize: "calc(.2027vw + 14.35135px)",
            fontWeight: 400,
            color
        },
        button: {
            fontSize: "calc(.27027vw + 15.13514px)",
            fontWeight: 400
        }
   }
});

const SHOULD_OPEN_SNACK_BAR_KEY = "shouldOpenSnackBar3";
const item = window.localStorage.getItem(SHOULD_OPEN_SNACK_BAR_KEY);

class App extends React.Component {
  public state = {
    open: !!JSON.parse(`${item === null ?  "true" : item}`)
  };

  public handleClose = () => {
    this.setState({ open: false });
    window.localStorage.setItem(SHOULD_OPEN_SNACK_BAR_KEY, "false");
  }

  public render() {
    const {open} = this.state;
    return (
        <MuiThemeProvider {...{theme}}>
          <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={open}
            onClose={this.handleClose}
            ContentProps={{
              'aria-describedby': 'message-id',
            }}
            message={<a style={{ color: "white", textDecoration: "none" }} target="_blank" href="http://start-react-native.dev" id="message-id">Learn React Native Gestures and Animations <span style={{ textDecoration: "underline" }}>here</span></a>}
            action={
                <Button color="inherit" size="small" onClick={this.handleClose}>
                  <Close />
                </Button>
              }
        />
            <BrowserRouter>
                <Switch>
                    <Route exact={true} path={Routes.home} component={Home}/>
                    <Route exact={true} path="/elements" component={Elements}/>
                    <Route exact={true} path="/boarding/:id" component={Boarding}/>
                    <Route exact={true} path="/promo" component={Promo} />
                    <Route exact={true} path="/discount" component={Discount} />
                    <Route exact={true} path="/buy-me-a-coffee" component={BuyMeACoffee} />
                    <Route component={PageNotFound} />
                </Switch>
            </BrowserRouter>
            <Footer />
        </MuiThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx